import React__default, { forwardRef, useRef } from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The toast that automatically closes. It should not be held open to acquire a user response.
 */
const Toast = /*#__PURE__*/forwardRef(({
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Root, _extends({
    ref: innerRef
  }, props));
});

/**
 * The toast that automatically closes. It should not be held open to acquire a user response.
 */
const Viewport = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Viewport, _extends({
    ref: innerRef
  }, props), children);
});

/**
 * The provider that wraps your toasts and toast viewport. It usually wraps the application.
 */
const Provider = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Provider, props, children);
};
Provider.displayName = "Provider";
/**
 * An optional title for the toast.
 */
const Title = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Title, _extends({
    ref: innerRef
  }, props), children);
});

/**
 * The toast message.
 */
const Description = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Description, _extends({
    ref: innerRef
  }, props), children);
});

/**
 * An action that is safe to ignore to ensure users are not expected to complete tasks with unexpected side effects as a result of a time limit.
 * When obtaining a user response is necessary, portal an AlertDialog styled as a toast into the viewport instead.
 */
const Action = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Action, _extends({}, props, {
    ref: innerRef
  }), children);
});

/**
 * A button that allows users to dismiss the toast before its duration has elapsed.
 */
const Close = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(ToastPrimitive.Close, _extends({
    ref: innerRef
  }, props), children);
});

// exports
Toast.displayName = 'Toast';
Viewport.displayName = 'Viewport';
Provider.displayName = 'Provider';
Title.displayName = 'Title';
Description.displayName = 'Description';
Action.displayName = 'Action';
Close.displayName = 'Close';

/** Toasts display a succinct message that is displayed temporarily. */
var Toast$1 = Object.assign(Toast, {
  Provider,
  Viewport,
  Title,
  Description,
  Action,
  Close
});

export { Toast$1 as default };
